"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUrlLastSlash = removeUrlLastSlash;
exports.addPathToUrl = addPathToUrl;
exports.getUniversalLink = getUniversalLink;
exports.openOKXDeeplink = openOKXDeeplink;
exports.openOKXUniversalLink = openOKXUniversalLink;
exports.openOKXDeeplinkWithFallback = openOKXDeeplinkWithFallback;
exports.getWindow = getWindow;
exports.isTelegramUrl = isTelegramUrl;
exports.encodeTelegramUrlParameters = encodeTelegramUrlParameters;
exports.encodeConnectParams = encodeConnectParams;
exports.encodeTWAConnectURLParams = encodeTWAConnectURLParams;
exports.getAppWalletDeepLink = getAppWalletDeepLink;
exports.getAppWalletShortDeepLink = getAppWalletShortDeepLink;
exports.getTelegramWalletTWAUrl = getTelegramWalletTWAUrl;
exports.openOKXTMAWalletlinkWithFallback = openOKXTMAWalletlinkWithFallback;
exports.isInTMA = isInTMA;
exports.isInTelegramBrowser = isInTelegramBrowser;
exports.getOKXLink = getOKXLink;
const protocol_1 = require("../protocol");
const log_1 = require("./log");
const constants_1 = require("../protocol/constants");
const utils_1 = require("./utils");
const tma_api_1 = require("./tma-api");
const constants_2 = require("../connect/constants");
function removeUrlLastSlash(url) {
    if (url.slice(-1) === '/') {
        return url.slice(0, -1);
    }
    return url;
}
function addPathToUrl(url, path) {
    return removeUrlLastSlash(url) + '/' + path;
}
function getUniversalLink(deeplinkUrl, useStandardUniversalLink = false) {
    console.log("getUniversalLink deeplinkUrl:", deeplinkUrl, ", useStandardUniversalLink:", useStandardUniversalLink);
    /*const replaceStrWithParam = `${standardDeeplink}?param=`
    if(!useStandardUniversalLink && deeplinkUrl.startsWith(replaceStrWithParam)){
        const cleanUrl = deeplinkUrl.replace(replaceStrWithParam, '');
        logDebug("getUniversalLink cleanUrl:",cleanUrl)
        const deeplinkEncodeUrl= encodeURIComponent(cleanUrl);
        logDebug("getUniversalLink standardUniversalLink:",standardUniversalLink)
        logDebug("getUniversalLink `${shortUniversalLink}?param=${deeplinkEncodeUrl}`:",`${shortUniversalLink}?param=${deeplinkEncodeUrl}`)
        return `${shortUniversalLink}?param=${deeplinkEncodeUrl}`;
    }else if(!useStandardUniversalLink && deeplinkUrl == standardDeeplink){
        logDebug("getUniversalLink shortUniversalLink:",shortUniversalLink)
        return shortUniversalLink;
    }else {
        const deeplinkEncodeUrl= encodeURIComponent(deeplinkUrl);
        console.log("getUniversalLink standardUniversalLink:",standardUniversalLink)

        return `${standardUniversalLink}?deeplink=${deeplinkEncodeUrl}`;
    }*/
    const deeplinkEncodeUrl = encodeURIComponent(deeplinkUrl);
    console.log("getUniversalLink standardUniversalLink:", protocol_1.standardUniversalLink);
    console.log("getUniversalLink standardUniversalLink:", `${protocol_1.standardUniversalLink}?deeplink=${deeplinkEncodeUrl}`);
    return `${protocol_1.standardUniversalLink}?deeplink=${deeplinkEncodeUrl}`;
}
function openOKXDeeplink(deeplinkUrl) {
    var _a;
    const fullUrl = getUniversalLink(deeplinkUrl);
    const isTelegram = !!((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.TelegramWebviewProxy);
    console.log("openOKXDeeplink fullUrl:", fullUrl);
    if (!(0, utils_1.isIos)() || (0, utils_1.isInIOSLine)()) {
        if (isTelegram) {
            window.open(deeplinkUrl, '_blank');
        }
        else {
            window.location.href = deeplinkUrl;
        }
    }
    else {
        openOKXUniversalLink(fullUrl);
    }
}
function openOKXUniversalLink(fullUrl) {
    if (!(0, utils_1.isIos)()) {
        // if (isTelegram) {
        window.open(fullUrl, '_blank');
        // } else {
        //     window.location.href = fullUrl;
        // }
    }
    else {
        if (isInTMA()) {
            window.open(fullUrl, '_blank');
        }
        else {
            console.log("windowOpen[before]: ", Date.now());
            if (window === null || window === void 0 ? void 0 : window.okxLogDebug) {
                window.open(fullUrl, '_blank');
            }
            else {
                window.open(fullUrl, '_self');
            }
            console.log("windowOpen[after]: ", Date.now());
        }
    }
}
function openOKXDeeplinkWithFallback(deeplinkUrl) {
    var _a;
    const fullUrl = getUniversalLink(deeplinkUrl);
    const isTelegram = !!((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.TelegramWebviewProxy);
    console.log("openOKXDeeplinkWithFallback fullUrl:", fullUrl);
    let deepLinkOpened = false;
    const timeoutDuration = 3000; // 1.5秒的等待时间
    const downloadUrl = protocol_1.standardUniversalLink;
    console.log("openOKXDeeplinkWithFallback standardUniversalLink:", protocol_1.standardUniversalLink);
    let newWindow = null;
    let fallbackToDownloadPage = () => {
        console.log("fallbackToDownloadPage :empty");
    };
    if (!(0, utils_1.isIos)()) {
        fallbackToDownloadPage = () => {
            if (!deepLinkOpened) {
                if (newWindow) {
                    newWindow.open(fullUrl, '_self');
                }
                else {
                    window.open(fullUrl, '_blank');
                }
            }
        };
    }
    else if ((0, utils_1.isInIOSLine)()) {
        fallbackToDownloadPage = () => {
            if (!deepLinkOpened) {
                window.open(fullUrl, '_self');
            }
        };
    }
    if (!(0, utils_1.isIos)() || (0, utils_1.isInIOSLine)() || (0, utils_1.isInIOSLark)() || (0, utils_1.isInIOSWeChat)()) {
        if (isTelegram) {
            newWindow = window.open(deeplinkUrl, '_blank');
        }
        else {
            window.location.href = deeplinkUrl;
        }
        setTimeout(fallbackToDownloadPage, timeoutDuration);
        let count = 0;
        let interval = setInterval(() => {
            count++;
            console.log("windowOpen --> interval:", count, document.hidden, document.visibilityState);
            if (count >= 10 || document.hidden) {
                deepLinkOpened = true;
                clearInterval(interval);
                console.log("windowOpen :cleat: ${count}");
            }
        }, 200);
        window.addEventListener('blur', () => {
            deepLinkOpened = true;
        }, { once: true });
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                deepLinkOpened = true;
            }
        });
    }
    else {
        if (isTelegram) {
            window.open(fullUrl, '_blank');
        }
        else {
            console.log("windowOpen[before]: ", Date.now());
            if (window === null || window === void 0 ? void 0 : window.okxLogDebug) {
                window.open(fullUrl, '_blank');
            }
            else {
                window.open(fullUrl, '_self');
            }
            console.log("windowOpen[after]: ", Date.now());
        }
    }
}
function getWindow() {
    if (typeof window !== 'undefined') {
        return window;
    }
    return undefined;
}
function isTelegramUrl(link) {
    if (!link) {
        return false;
    }
    const url = new URL(link);
    return url.protocol === 'tg:' || url.hostname === 't.me';
}
function encodeTelegramUrlParameters(parameters) {
    let encodedParameters = parameters;
    encodedParameters = encodedParameters.replace(/\./g, '%2E');
    encodedParameters = encodedParameters.replace(/-/g, '%2D');
    encodedParameters = encodedParameters.replace(/_/g, '%5F');
    encodedParameters = encodedParameters.replace(/&/g, '-');
    encodedParameters = encodedParameters.replace(/=/g, '__');
    encodedParameters = encodedParameters.replace(/%/g, '--');
    return encodedParameters;
}
function encodeConnectParams(connectRequest) {
    let connectRequestWithVersion = Object.assign(Object.assign({}, connectRequest), { protocolVersion: constants_2.CONNECT_PROTOCOL_VER });
    const connectRequestStr = JSON.stringify(connectRequestWithVersion);
    (0, log_1.logDebug)("url encodeConnectParams connectRequestStr ", connectRequestStr);
    const utf8Array = new TextEncoder().encode(connectRequestStr);
    const base64Encoded = btoa(String.fromCharCode(...utf8Array));
    // .replace(/\+/g, '-')
    // .replace(/\//g, '_')
    // .replace(/=+$/, ''); //Compatible with older versions of iOS. Cannot be added directly  (Base64 URL Safe)
    (0, log_1.logDebug)("url encodeConnectParams base64Encoded ", base64Encoded);
    return base64Encoded;
}
function encodeTWAConnectURLParams(connectRequest) {
    const connectRequestStr = JSON.stringify({ topic: connectRequest.topic, clientId: connectRequest.clientId });
    (0, log_1.logDebug)("url encodeConnectParams connectRequestStr", connectRequestStr);
    const utf8Array = new TextEncoder().encode(connectRequestStr);
    const base64Encoded = btoa(String.fromCharCode(...utf8Array));
    return base64Encoded;
}
function getAppWalletDeepLink(connectParam) {
    return `${protocol_1.standardDeeplink}?param=${connectParam}`;
}
function getAppWalletShortDeepLink(topic, clientId) {
    return `${constants_1.shortUniversalLink}?topic=${topic}${(0, utils_1.getLastSixMd5Hash)(clientId)}`;
}
//  make telegram okx wallet TWA url
function getTelegramWalletTWAUrl(connectParam, redirectStr) {
    let base64Content = { okxconnect: "", redirect: "", extraparams: "", fromtg: false };
    if (connectParam) {
        base64Content.okxconnect = connectParam;
    }
    if (redirectStr) {
        base64Content.redirect = redirectStr;
    }
    if (!isInTMA()) {
        base64Content.fromtg = false;
    }
    else {
        base64Content.fromtg = true;
    }
    (0, log_1.logDebug)('getTelegramWalletTWAUrl redirect:', base64Content.redirect);
    let base64ContentStr = JSON.stringify(base64Content);
    const utf8Array = new TextEncoder().encode(base64ContentStr);
    const base64Encoded = btoa(String.fromCharCode(...utf8Array));
    const urlSafeBase64 = (0, utils_1.toSafeBase64FromBase64)(base64Encoded);
    (0, log_1.logDebug)('[TWA] open link:', base64Content, base64Encoded);
    if (connectParam || redirectStr) {
        if (!isInTMA()) {
            // return `http://localhost:5173?tgWebAppStartParam=${urlSafeBase64}`
            if ((0, constants_1.getTestTwaUrl)()) {
                return `${(0, constants_1.getTestTwaUrl)()}?tgWebAppStartParam=${urlSafeBase64}`;
            }
            else if ((0, constants_1.getTestTgTwaUrl)()) {
                let result = (0, constants_1.getBotNameAndAppName)((0, constants_1.getTestTgTwaUrl)());
                if (result) {
                    let { botName, appName } = result;
                    return `tg://resolve?domain=${botName}&appname=${appName}&startapp=${urlSafeBase64}`;
                }
                return `tg://resolve?domain=${constants_1.tgwalletName}&appname=${constants_1.tgwalletAppName}&startapp=${urlSafeBase64}`;
            }
            else {
                return `tg://resolve?domain=${constants_1.tgwalletName}&appname=${constants_1.tgwalletAppName}&startapp=${urlSafeBase64}`;
            }
        }
        else {
            if ((0, constants_1.getTestTgTwaUrl)()) {
                return `${(0, constants_1.getTestTgTwaUrl)()}?startapp=${urlSafeBase64}`;
            }
            else {
                return `https://t.me/${constants_1.tgwalletName}/start?startapp=${urlSafeBase64}`;
            }
        }
    }
    if (!isInTMA()) {
        // return "http://localhost:5173"
        if ((0, constants_1.getTestTwaUrl)()) {
            return `${(0, constants_1.getTestTwaUrl)()}`;
        }
        else if ((0, constants_1.getTestTgTwaUrl)()) {
            let result = (0, constants_1.getBotNameAndAppName)((0, constants_1.getTestTgTwaUrl)());
            if (result) {
                let { botName, appName } = result;
                return `tg://resolve?domain=${botName}&appname=${appName}`;
            }
            return `tg://resolve?domain=${constants_1.tgwalletName}&appname=${constants_1.tgwalletAppName}`;
        }
        else {
            return `tg://resolve?domain=${constants_1.tgwalletName}&appname=${constants_1.tgwalletAppName}`;
        }
    }
    else {
        if ((0, constants_1.getTestTgTwaUrl)()) {
            return `${(0, constants_1.getTestTgTwaUrl)()}`;
        }
        else {
            return `https://t.me/${constants_1.tgwalletName}/start`;
        }
    }
}
//  open TWA url in telegram
function openOKXTMAWalletlinkWithFallback(twaDeepLink) {
    var _a, _b, _c, _d, _e;
    (0, log_1.logDebug)('[TWA] open link:', twaDeepLink, "isInTMA ==> ", isInTMA());
    if (!isInTMA()) {
        if ((0, constants_1.getTestTwaUrl)()) {
            window.open(twaDeepLink, '_blank');
        }
        else {
            window.open(twaDeepLink, '_self');
        }
    }
    else {
        if ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.Telegram) === null || _b === void 0 ? void 0 : _b.WebApp) {
            (_e = (_d = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.Telegram) === null || _d === void 0 ? void 0 : _d.WebApp) === null || _e === void 0 ? void 0 : _e.openTelegramLink(twaDeepLink);
        }
        else {
            (0, tma_api_1.sendOpenTelegramLink)(twaDeepLink);
        }
    }
}
/**
 * Returns true if the app is running in TMA.
 */
function urlSafeDecode(urlencoded) {
    try {
        urlencoded = urlencoded.replace(/\+/g, '%20');
        return decodeURIComponent(urlencoded);
    }
    catch (e) {
        return urlencoded;
    }
}
function urlParseQueryString(queryString) {
    let params = {};
    if (!queryString.length) {
        return params;
    }
    let queryStringParams = queryString.split('&');
    let i, param, paramName, paramValue;
    for (i = 0; i < queryStringParams.length; i++) {
        param = queryStringParams[i].split('=');
        paramName = urlSafeDecode(param[0]);
        paramValue = param[1] == null ? null : urlSafeDecode(param[1]);
        params[paramName] = paramValue;
    }
    return params;
}
function urlParseHashParams(locationHash) {
    locationHash = locationHash.replace(/^#/, '');
    let params = {};
    if (!locationHash.length) {
        return params;
    }
    if (locationHash.indexOf('=') < 0 && locationHash.indexOf('?') < 0) {
        params._path = urlSafeDecode(locationHash);
        return params;
    }
    let qIndex = locationHash.indexOf('?');
    if (qIndex >= 0) {
        let pathParam = locationHash.substr(0, qIndex);
        params._path = urlSafeDecode(pathParam);
        locationHash = locationHash.substr(qIndex + 1);
    }
    let query_params = urlParseQueryString(locationHash);
    for (let k in query_params) {
        params[k] = query_params[k];
    }
    return params;
}
let initParams = {};
try {
    let locationHash = location.hash.toString();
    initParams = urlParseHashParams(locationHash);
}
catch (e) { }
let tmaPlatform = 'unknown';
if (initParams === null || initParams === void 0 ? void 0 : initParams.tgWebAppPlatform) {
    tmaPlatform = (_a = initParams.tgWebAppPlatform) !== null && _a !== void 0 ? _a : 'unknown';
}
if (tmaPlatform === 'unknown') {
    const window = getWindow();
    tmaPlatform = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.Telegram) === null || _b === void 0 ? void 0 : _b.WebApp) === null || _c === void 0 ? void 0 : _c.platform) !== null && _d !== void 0 ? _d : 'unknown';
}
function isInTMA() {
    var _a;
    return tmaPlatform !== 'unknown' || !!((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.TelegramWebviewProxy);
}
/**
 * Returns true if the app is running in the Telegram browser.
 */
function isInTelegramBrowser() {
    var _a;
    const isTelegramWebview = !!((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.TelegramWebview);
    return (isInTMA() || isTelegramWebview) && tmaPlatform === 'unknown';
}
function getOKXLink(connectRequest, useMini = false, tmaReturnUrl) {
    (0, log_1.logDebug)(`url  getOKXLink() called connectRequest==> ${JSON.stringify(connectRequest)}  useMini=> ${useMini}  tmaReturnUrl==> ${tmaReturnUrl}`);
    if (useMini) {
        if (connectRequest) {
            var encodeTGParams = encodeTWAConnectURLParams(connectRequest);
            return getTelegramWalletTWAUrl(encodeTGParams, tmaReturnUrl !== null && tmaReturnUrl !== void 0 ? tmaReturnUrl : "back");
        }
        else {
            return getTelegramWalletTWAUrl(undefined, tmaReturnUrl !== null && tmaReturnUrl !== void 0 ? tmaReturnUrl : "back");
        }
    }
    else {
        if ((0, utils_1.useShortLink)()) {
            if (connectRequest) {
                return getAppWalletShortDeepLink(connectRequest.topic, connectRequest.clientId);
            }
            else {
                return constants_1.shortUniversalLink;
            }
        }
        else {
            if (connectRequest) {
                const base64Encoded = encodeConnectParams(connectRequest);
                return `${protocol_1.standardDeeplink}?param=${base64Encoded}`;
            }
            else {
                return protocol_1.standardDeeplink;
            }
        }
    }
}
